const OrderHistory = () => import("./views/OrderHistory.vue");
const Renewal = () => import("./views/Renewal.vue");
const RenewalForm = () => import("./views/RenewalForm.vue");

export default [
  {
    path: "order-history",
    component: OrderHistory,
  },
  {
    path: "renew",
    component: Renewal,
  },
  {
    path: "renew/module",
    component: RenewalForm,
  },
];
